import { render } from "./ConfirmAccountForm.vue?vue&type=template&id=5ab463db"
import script from "./js/confirmAccountForm.js?vue&type=script&lang=js&external"
export * from "./js/confirmAccountForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__